import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { track, WHATSAPP_URL } from "@/lib/api";

export default function ThankYou() {
  useEffect(() => {
    track("thank_you_view");
  }, []);

  return (
    <section data-testid="thank-you-page" className="min-h-[90vh] flex items-center justify-center bg-[#070E1E] px-4 pt-20">
      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-lg w-full bg-white rounded-3xl p-10 sm:p-14 text-center shadow-2xl"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 200, damping: 14, delay: 0.2 }}
        >
          <CheckCircle2 className="w-16 h-16 text-[#059669] mx-auto mb-6" />
        </motion.div>
        <h1 className="text-3xl font-black tracking-tight text-[#0B192C]">THANK YOU!</h1>
        <p className="mt-4 text-slate-600 leading-relaxed">
          Your profile has been submitted to Harwell Global Education.
          <strong className="block mt-2 text-[#0B192C]">A counsellor will contact you regarding suitable study options.</strong>
        </p>
        <div className="mt-9 flex flex-col sm:flex-row justify-center gap-3">
          <Link
            to="/study-in-romania"
            data-testid="thank-you-explore-btn"
            className="px-6 py-3.5 rounded-full text-sm font-bold text-white bg-[#1E40AF] hover:bg-[#1D4ED8] transition-all flex items-center justify-center gap-2"
          >
            EXPLORE ROMANIA 2026 <ArrowRight className="w-4 h-4" />
          </Link>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { source: "thank_you" })}
            data-testid="thank-you-whatsapp-btn"
            className="px-6 py-3.5 rounded-full text-sm font-bold text-white bg-[#059669] hover:bg-[#047857] transition-all"
          >
            WHATSAPP US
          </a>
        </div>
        <Link to="/" data-testid="thank-you-home-link" className="inline-block mt-6 text-xs font-semibold text-slate-400 hover:text-slate-600">
          Back to homepage
        </Link>
      </motion.div>
    </section>
  );
}
